import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addemptype',
  templateUrl: './addemptype.component.html',
  styleUrls: ['./addemptype.component.css']
})
export class AddemptypeComponent implements OnInit ,AfterViewInit {

  @ViewChildren('input')firstipcontrol;

  formname:String="EmpType"; 

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
isprivilage: boolean = false;
showProgress: boolean = false;

//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;

//Edit Get Values
emptypeColl:any=[];
emptypeBO:any={};
emptypeid:number=0

emptypeform=new FormGroup({
  emptypeid:new FormControl(0),          
  emptypename:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.emptypeid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
   try{
       this.isaddmode=true;
       this.emptypeform.reset();
       this.fnInitializeFormGroup(); 

       if(this.emptypeid>0){
         this.fngetEmpType();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.emptypeid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}
ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}
fnInitializeFormGroup(){
   this.emptypeform.setValue({
      emptypeid:0,    
      emptypename:'',
     inactive:false              
   })
}

//Get 
fngetEmpType() {
  if (this.showProgress) {
    return;
  }         
     var data = {
       'emptypeid':this.emptypeid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getEmpType(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){ 
          this.fnHideProgress();
 
           this.emptypeColl=res.json().result;
           var editdata = this.emptypeColl[0];        
           this.fnEditMode(editdata);
           this.emptypeBO=editdata;
         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{
      this.fnHideProgress();
          
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{
    if (this.saveloading) {
      return;
    }

     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.emptypeform.valid){
         //Check
         this.saveloading = true;
         var data = {
               'emptypeid': this.emptypeid,                      
               'emptypename':this.emptypeform.get('emptypename').value, 
               'inactive':this.emptypeform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                             
         }

       
         this.appService.fnCheckEmpType(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.emptypeform.get('emptypeid').value>0){
                       //Update 
                       this.fnSetEmpType(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertEmpType(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){this.saveloading = false;
                       this.emptypeform.controls['emptypename'].setErrors({'notfound': true});
                     }
               }
             }
             else {this.saveloading = false;
               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{this.saveloading = false;
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){this.saveloading = false;
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertEmpType(data){    
 
   this.appService.fnInsertEmpType(data).subscribe(
     (res)=>{this.saveloading = false;
       if(res.json().status===200){  
         if(res.json().result!=""){
           this.toastr.success('', "The new emptype has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.emptypename);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{this.saveloading = false;
       this.toastr.error('Error', err);
     });

}

//Set
fnSetEmpType(data){    

this.appService.fnSetEmpType(data).subscribe(
 (res)=>{this.saveloading = false;
   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The emptype has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.emptypeid,data.emptypename);

             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{this.saveloading = false;
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  this.router.navigate(['/EmpType']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.emptypeform.setValue({ 
  emptypeid:deptBO.emptypeid,     
  emptypename:deptBO.emptypename,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}


fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}
private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}







}
